'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.setInlineCartAccountStateUI = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

var _Toggle = require('components/Toggle');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable camelcase */
var setInlineCartAccountStateUI = exports.setInlineCartAccountStateUI = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
    var _ref2, itemCount;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = data ? data.state : _state2.default.get('cart'), itemCount = _ref2.item_count;


            if (itemCount > 0) {
              $('.variation-2 ' + _Dom2.default.cartAccountInline).show();
              $(_Dom2.default.cartFull).show();
              $(_Dom2.default.cartAccountDrawer).show();
              $(_Dom2.default.cartShippingHeader).show();
            } else {
              $(_Dom2.default.cartAccountInline).hide();
              $(_Dom2.default.cartFull).hide();
              $(_Dom2.default.cartAccountDrawer).hide();
              $(_Dom2.default.cartShippingHeader).hide();
            }

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function setInlineCartAccountStateUI(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updateInlineCartUI = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
    var requests, _ref4, openInlineCart, cartContents, subtotal, _ref5, _ref6, newCart, newSubtotal;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requests = _state2.default.get('request');
            _ref4 = data.requestData || {}, openInlineCart = _ref4.openInlineCart;


            PubSub.publish(_Constants2.default.updateInlineCartUIStart, {});

            if (!(requests.length === 0)) {
              _context2.next = 14;
              break;
            }

            cartContents = (0, _Helpers.getAlternativeTemplate2)({
              resource: 'cart',
              templateName: 'ajax-inline-cart-contents'
            });
            subtotal = (0, _Helpers.getAlternativeTemplate2)({
              resource: 'cart',
              templateName: 'ajax-subtotal'
            });
            _context2.next = 8;
            return Promise.all([cartContents, subtotal]);

          case 8:
            _ref5 = _context2.sent;
            _ref6 = (0, _slicedToArray3.default)(_ref5, 2);
            newCart = _ref6[0];
            newSubtotal = _ref6[1];


            $(_Dom2.default.inlineCartContents).html(newCart);
            $(_Dom2.default.inlineCartSubtotal).replaceWith(newSubtotal);

          case 14:

            PubSub.publish(_Constants2.default.updateInlineCartUISuccess, {});

            if (openInlineCart !== false) {
              PubSub.publish(_Constants2.default.openInlineCart, {});
            }

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function updateInlineCartUI(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var _getLineItemsContainerHeight = function _getLineItemsContainerHeight() {
  var _this = this;

  var consumedHeight = 0;
  var inlineCartHeight = $('[data-inline-cart]').height();

  $('[data-inline-cart] > *:not([data-cart-contents])').each(function () {
    var $el = $(_this);

    if ($el.is(':visible')) {
      consumedHeight += $el[0].scrollHeight;
    }
  });

  return inlineCartHeight - consumedHeight;
};

var openInlineCart = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            setTimeout(function () {
              $(_Dom2.default.mobileCartIcon).hide();
              $(_Dom2.default.mobileCartCloseIcon).show();
              $(_Dom2.default.body).addClass(_Dom2.default.cartIsActive);
              $(_Dom2.default.toggleInlineCart + ', ' + _Dom2.default.closeInlineCart).attr('aria-expanded', 'true');
              $('[data-inline-cart]').css('max-height', window.innerHeight - 55 + 'px').addClass('is-active');

              $(window).resize(function () {
                $('[data-inline-cart]').css('max-height', window.innerHeight - 55 + 'px');
                $('[data-cart-contents]').css('max-height', _getLineItemsContainerHeight());
              });
            }, 100);

            return _context3.abrupt('return', (0, _Toggle.toggleElement)({ selector: _Dom2.default.overlay, action: 'add', animated: true }).then(function () {
              (0, _Toggle.toggleElement)({ selector: _Dom2.default.inlineCart, action: 'add', animated: true });
            }));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function openInlineCart() {
    return _ref7.apply(this, arguments);
  };
}();

var closeInlineCart = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setTimeout(function () {
              $(_Dom2.default.mobileCartIcon).show();
              $(_Dom2.default.mobileCartCloseIcon).hide();
              $(_Dom2.default.body).removeClass(_Dom2.default.cartIsActive);
              $(_Dom2.default.toggleInlineCart + ', ' + _Dom2.default.closeInlineCart).attr('aria-expanded', 'false');
            }, 100);

            return _context4.abrupt('return', (0, _Toggle.toggleElement)({ selector: _Dom2.default.inlineCart, action: 'remove', animated: true }).then(function () {
              (0, _Toggle.toggleElement)({ selector: _Dom2.default.overlay, action: 'remove', animated: true });
            }));

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function closeInlineCart() {
    return _ref8.apply(this, arguments);
  };
}();

var toggleInlineCart = function toggleInlineCart(data) {
  var inlineCartOpen = $(_Dom2.default.inlineCart).is(_Dom2.default.isActive);

  return inlineCartOpen ? closeInlineCart(data) : openInlineCart(data);
};

var getGiftBoxRelatedCartTotals = function getGiftBoxRelatedCartTotals(cart) {
  var watchTypes = ['Men\'s Watch', 'Women\'s Watch'];
  var braceletTypes = ['Mens Bracelets', 'Womens Bracelets'];
  var strapTypes = ['Band'];

  return cart.items.reduce(function (totals, _ref9) {
    var productType = _ref9.product_type,
        quantity = _ref9.quantity;

    if (watchTypes.includes(productType)) {
      return Object.assign({}, totals, { watches: totals.watches + quantity || quantity });
    } else if (braceletTypes.includes(productType)) {
      return Object.assign({}, totals, { bracelets: totals.bracelets + quantity || quantity });
    } else if (strapTypes.includes(productType)) {
      return Object.assign({}, totals, { straps: totals.straps + quantity || quantity });
    }

    return totals;
  }, {});
};

var getGiftBoxLineItemAdjustments = function getGiftBoxLineItemAdjustments(requests, _ref10) {
  var type = _ref10.type,
      variantId = _ref10.variantId;

  var cart = _state2.default.get('cart');

  var _ref11 = cart.items.find(function (_ref12) {
    var variant_id = _ref12.variant_id;
    return variant_id === variantId;
  }) || {},
      key = _ref11.key,
      _ref11$quantity = _ref11.quantity,
      actual = _ref11$quantity === undefined ? 0 : _ref11$quantity;

  var _getGiftBoxRelatedCar = getGiftBoxRelatedCartTotals(cart),
      _getGiftBoxRelatedCar2 = _getGiftBoxRelatedCar.watches,
      watches = _getGiftBoxRelatedCar2 === undefined ? 0 : _getGiftBoxRelatedCar2,
      _getGiftBoxRelatedCar3 = _getGiftBoxRelatedCar.bracelets,
      bracelets = _getGiftBoxRelatedCar3 === undefined ? 0 : _getGiftBoxRelatedCar3,
      _getGiftBoxRelatedCar4 = _getGiftBoxRelatedCar.straps,
      straps = _getGiftBoxRelatedCar4 === undefined ? 0 : _getGiftBoxRelatedCar4;

  var updatedWatchAndStrapCount = Math.min(watches, straps);
  var updatedWatchAndBraceletCount = Math.min(watches - updatedWatchAndStrapCount, bracelets);
  var updated = type === 'strap' ? updatedWatchAndStrapCount : updatedWatchAndBraceletCount;
  var changeBy = updated - actual;

  if (changeBy === 0) return requests;

  var requestOptions = {};

  if (actual === 0) {
    requestOptions.method = 'addItem';
    requestOptions.args = [variantId, { quantity: changeBy, properties: { _center: '1003' } }];
  } else if (updated === 0) {
    requestOptions.method = 'removeItem';
    requestOptions.args = [key];
  } else {
    requestOptions.method = 'updateItem';
    requestOptions.args = [key, { quantity: updated }];
  }

  return [].concat((0, _toConsumableArray3.default)(requests), [Object.assign({}, requestOptions, {
    openInlineCart: false
  })]);
};

var adjustGiftBoxLineItems = function adjustGiftBoxLineItems() {
  var upsells = _state2.default.get('upsell');
  var checkout = _state2.default.get('checkout');

  if (upsells.giftBox && checkout.active === false) {
    var requests = [{ type: 'strap', variantId: 13099142217810 }, { type: 'bracelet', variantId: 27492865929 }].reduce(getGiftBoxLineItemAdjustments, []);

    if (requests.length > 0) {
      PubSub.publish(_Constants2.default.batchRequests, requests);
    }
  }
};

var init = exports.init = function init() {
  var upsells = _state2.default.get('upsell');
  setInlineCartAccountStateUI();
  _Flow2.default.localize();

  if (upsells.giftBox) {
    adjustGiftBoxLineItems();
  }
};

exports.default = {
  init: init,
  updateUI: updateInlineCartUI,
  updateAccountUI: setInlineCartAccountStateUI,
  open: openInlineCart,
  close: closeInlineCart,
  toggle: toggleInlineCart,
  adjustGiftBoxLineItems: adjustGiftBoxLineItems
  // disableLineItemActions,
  // enableLineItemActions,
};